import { useState } from "react";
import { Box, Button, styled, Typography } from "@mui/material";
import { SuperHeroWheelPng } from "../constants/images";
import { Link } from "react-router-dom";
import { FaStar, FaXTwitter } from "react-icons/fa6";
import { FaDiscord, FaTelegramPlane } from "react-icons/fa";
import { addToWaitlist } from "../services/googleSheets";
import { getGeoLocation } from "../utils/geoLocation";

export const Home = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleJoinWaitlist = async () => {
    try {
      if (!email) {
        setMessage("Please enter your email address");
        setIsSuccess(false);
        return;
      }
      if (!validateEmail(email)) {
        setMessage("Please enter a valid email address");
        setIsSuccess(false);
        return;
      }

      const geoLocation = await getGeoLocation();
      const ipAddress = geoLocation?.ip;

      console.log({ ipAddress });

      if (ipAddress) {
        const response = await addToWaitlist(email, ipAddress);
        console.log({ response });
        if (response.success) {
          setMessage("Email added to waitlist successfully!");
          setIsSuccess(true);
          setEmail(""); // Clear the input
        } else {
          setMessage(response.message);
          setIsSuccess(false);
        }
      }
    } catch (error) {
      setMessage("An error occurred. Please try again.");
      setIsSuccess(false);
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (message) {
      setMessage("");
      setIsSuccess(false);
    }
  };

  return (
    <Container>
      <EarnSection>
        <EarnSectionLeft>
          <EarnTitleContainer>
            <EarnSubTitle>
              BetSave <br />
              is <span>Coming Soon</span>
            </EarnSubTitle>
            <EarnDescription>
              Get cashback on your favorite casinos. Be the first to join.
            </EarnDescription>
          </EarnTitleContainer>
          <EarnAction>
            <JoinInputWrapper>
              <JoinInputContainer error={!!message && !isSuccess}>
                <JoinInput
                  placeholder="Enter your email"
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                />
                <JoinButton onClick={handleJoinWaitlist}>
                  Join Waitlist
                </JoinButton>
              </JoinInputContainer>
              {message && (
                <MessageText isSuccess={isSuccess}>{message}</MessageText>
              )}
            </JoinInputWrapper>
            <CommunityLinkContainer>
              <Link to="https://x.com/betsaveio" target="_blank">
                <LinkButton>
                  <FaXTwitter />
                </LinkButton>
              </Link>
              <Link to="https://discord.gg/4zDPqJ2C8P" target="_blank">
                <LinkButton>
                  <FaDiscord />
                </LinkButton>
              </Link>
              <Link to="https://t.me/+GxOf65TFMEE1YTI9" target="_blank">
                <LinkButton>
                  <FaTelegramPlane />
                </LinkButton>
              </Link>
            </CommunityLinkContainer>
          </EarnAction>
          <IncentiveContainer>
            <FaStar />
            <IncentiveText>
              Early users get extra cashback bonuses and exclusive promos on
              launch.
            </IncentiveText>
          </IncentiveContainer>
        </EarnSectionLeft>
        <MarketImg src={SuperHeroWheelPng} alt="market" />
      </EarnSection>
      <Box></Box>
    </Container>
  );
};

const Container = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "100px",
  maxWidth: "1960px",
  [theme.breakpoints.down(1440)]: {
    gap: "80px",
  },

  [theme.breakpoints.down(540)]: {
    gap: "40px",
  },
}));

const EarnSection = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: "75px 0px 0px 60px",
  display: "flex",
  justifyContent: "space-between",
  gap: "20px",
  position: "relative",
  [theme.breakpoints.down(1440)]: {
    padding: "45px 0px 0px 30px",
  },
  [theme.breakpoints.down(960)]: {
    justifyContent: "center",
    flexDirection: "column-reverse",
    alignItems: "center",
  },
  [theme.breakpoints.down(540)]: {
    padding: "0",
  },
}));

const EarnSectionLeft = styled(Box)(({ theme }) => ({
  width: "700px",
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  [theme.breakpoints.down(1650)]: {
    width: "540px",
  },
  [theme.breakpoints.down(1280)]: {
    width: "400px",
  },
  [theme.breakpoints.down(960)]: {
    width: "100%",
  },
  [theme.breakpoints.down(480)]: {
    gap: "20px",
  },
}));

const EarnTitleContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "14px",
  [theme.breakpoints.down(480)]: {
    gap: "10px",
  },
}));

const EarnSubTitle = styled(Typography)(({ theme }) => ({
  fontSize: "84px",
  fontWeight: "700",
  color: "#fff",
  lineHeight: "120%",
  span: {
    color: "#1AE5A1",
  },
  [theme.breakpoints.down(1650)]: {
    fontSize: "64px",
  },
  [theme.breakpoints.down(1280)]: {
    fontSize: "54px",
  },
  [theme.breakpoints.down(540)]: {
    fontSize: "42px",
  },
  [theme.breakpoints.down(480)]: {
    fontSize: "32px",
  },
}));

const EarnDescription = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: "400",
  color: "#627691",
  width: "540px",
  [theme.breakpoints.down(1280)]: {
    fontSize: "16px",
    width: "400px",
  },
  [theme.breakpoints.down(480)]: {
    fontSize: "14px",
    width: "100%",
  },
}));

const EarnAction = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

const MarketImg = styled("img")(({ theme }) => ({
  width: "1200px",
  height: "auto",
  objectFit: "cover",
  position: "absolute",
  top: "-30%",
  right: "-10%",
  zIndex: "-1",
  [theme.breakpoints.down(1650)]: {
    right: "-15%",
  },
  [theme.breakpoints.down(1440)]: {
    width: "1000px",
    top: "-20%",
  },
  [theme.breakpoints.down(1280)]: {
    width: "900px",
    right: "-15%",
  },
  [theme.breakpoints.down(1140)]: {
    width: "800px",
    right: "-20%",
  },
  [theme.breakpoints.down(960)]: {
    width: "1000px",
    position: "static",
    marginTop: "-200px",
    marginRight: "30px",
  },
  [theme.breakpoints.down(640)]: {
    width: "800px",
    marginTop: "-150px",
    marginRight: "54px",
  },
  [theme.breakpoints.down(540)]: {
    width: "700px",
    marginTop: "-100px",
    marginRight: "24px",
  },
  [theme.breakpoints.down(480)]: {
    width: "600px",
    marginRight: "10px",
  },
  [theme.breakpoints.down(380)]: {
    width: "500px",
    marginRight: "0px",
  },
}));

const JoinInputWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  height: "80px",
  [theme.breakpoints.down(640)]: {
    height: "70px",
  },
}));

const JoinInputContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "error",
})<{ error?: boolean }>(({ theme, error }) => ({
  width: "400px",
  height: "60px",
  borderRadius: "10px",
  border: error ? "0.5px solid #ff4d4f" : "0.5px solid #62769133",
  backgroundColor: "#0f1629",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down(640)]: {
    width: "100%",
    height: "50px",
  },
}));

const JoinInput = styled("input")(({ theme }) => ({
  width: "100%",
  height: "100%",
  backgroundColor: "transparent",
  border: "none",
  outline: "none",
  padding: "0 20px",
  fontSize: "20px",
  fontWeight: "500",
  color: "#fff",
  fontFamily: "SpaceGrotesk",
  "&::placeholder": {
    color: "#627691",
  },
  [theme.breakpoints.down(640)]: {
    fontSize: "16px",
  },
}));

const JoinButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#1AE5A1",
  color: "#000",
  borderRadius: "10px",
  padding: "0 30px",
  minWidth: "175px",
  textWrap: "nowrap",
  height: "60px",
  fontSize: "20px",
  fontWeight: "700",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down(640)]: {
    fontSize: "16px",
    height: "50px",
    minWidth: "140px",
    padding: "0 20px",
  },
  [theme.breakpoints.down(380)]: {
    minWidth: "120px",
    fontSize: "14px",
  },
}));

const CommunityLinkContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "10px",
  marginTop: "10px",
}));

const LinkButton = styled(Button)(({ theme }) => ({
  width: "60px",
  height: "60px",
  minWidth: "60px",
  borderRadius: "10px",
  background: "linear-gradient(180deg, #172236 0%, #212C40 100%)",
  border: "1.2px solid rgba(255, 255, 255, 0.1)",
  color: "#fff",
  fontSize: "32px",
  transition: "all 0.3s ease",
  position: "relative",
  overflow: "hidden",

  "&:hover": {
    background: "linear-gradient(180deg, #1a2a45 0%, #25354a 100%)",
    transform: "translateY(-2px)",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
    border: "1.2px solid rgba(255, 255, 255, 0.2)",
    "& svg": {
      transform: "scale(1.1)",
    },
  },

  "& svg": {
    transition: "transform 0.3s ease",
  },

  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent)",
    transform: "translateX(-100%)",
    transition: "transform 0.6s ease",
  },

  "&:hover::before": {
    transform: "translateX(100%)",
  },

  [theme.breakpoints.down(1600)]: {
    width: "50px",
    height: "50px",
    minWidth: "50px",
    fontSize: "24px",
  },
}));

const IncentiveContainer = styled(Box)(({ theme }) => ({
  width: "450px",
  height: "80px",
  background: "#FEE8970D",
  borderRadius: "10px",
  padding: "16px 23px",
  display: "flex",
  alignItems: "center",
  gap: "20px",
  svg: {
    width: "30px",
    minWidth: "30px",
    minHeight: "30px",
    height: "30px",
    color: "#FEE897",
    [theme.breakpoints.down(640)]: {
      width: "20px",
      minWidth: "20px",
      minHeight: "20px",
      height: "20px",
    },
  },
  [theme.breakpoints.down(640)]: {
    width: "100%",
  },
}));

const IncentiveText = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  color: "#FEE897",
  [theme.breakpoints.down(640)]: {
    fontSize: "14px",
  },
}));

const MessageText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isSuccess",
})<{ isSuccess?: boolean }>(({ theme, isSuccess }) => ({
  color: isSuccess ? "#1AE5A1" : "#ff4d4f",
  fontSize: "14px",
  marginTop: "4px",
  marginLeft: "4px",
}));
